import { render } from "./btn-url-action.vue?vue&type=template&id=2a06d6d0"
import script from "./btn-url-action.js?vue&type=script&lang=js&external"
export * from "./btn-url-action.js?vue&type=script&lang=js&external"

import "./btn-url-action.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__